import { useState } from "react";
import { FaUpload } from "react-icons/fa"
import { uploadFileAdmin } from "../../../services/apis/general";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { toastConfig, userToken } from "../../../helpers/helper";

const Admin=()=>{
    const {t} = useTranslation()
    const [loadingFiles,setLoadingFiles] = useState(false)

    const handleChangeFiles = (e) => {
        let files = e.target.files[0];
        uploadFile(files);
      };
    
      const uploadFile = async (data) => {
        setLoadingFiles(true);
        const formData = new FormData();
    
          formData.append(`file`, data);
        try {
          const response = await uploadFileAdmin(formData);

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
    
        link.setAttribute("download", "Register Users" + "." + "xlsx"); 
  
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
        window.URL.revokeObjectURL(url);
          
          toast.success(
            t('admin.fileUploaded'),
            toastConfig,
            setLoadingFiles(false)
          );
        } catch (error) {
          if (error.response) {
            if (error.response.status == 400) {
              toast.error(
                error.response.data.message,
                toastConfig,
                setLoadingFiles(false)
              );
            } else if (error.response.status == 500) {
              toast.error(
                error.response.data.message,
                toastConfig,
                setLoadingFiles(false)
              );
            }
          }
        }
      };
    return(
        <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-10">
            {!userToken ? (
                <div className="w-[90%] mr-auto ml-auto text-center">{"لا تستطيع مشاهدة المحتوي"}</div>
            ):(
        <div className="w-[90%] mr-auto ml-auto">
            <div className="text-[20px] font-700 text-[#3E0292]">{t("admin.title")}</div>
            <div class="w-full mx-auto mt-5">
                <label class="block border bg-[#ffffff] border-gray-300 rounded-lg p-2 flex items-center cursor-pointer w-[100%] p-3">
                  <FaUpload className="text-[#3E0292]" />
                  <div className="text-[#3E0292] font-400 mx-3">
                    {t('admin.uploadFile')}
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    multiple={true}
                    label={t('myOrders.uploadFiles')}
                    placeholder={t('myOrders.selectFiles')}
                    onChange={(e) => handleChangeFiles(e)}
                    accept=".xls,.xlsx"
                  />
                </label>
              </div>
        </div>
        )}
        </div>
    )
}
export default Admin